/**
 * useIsAdmin — may the current user administer App Support in this app?
 *
 * A deliberately minimal role check, not a permissions framework. The
 * template needs exactly one question answered ("do I draw the admin
 * surfaces?"), and the roles that answer it differ per app, so the answer
 * comes from `VITE_ADMIN_ROLE` rather than from a hard-coded map.
 *
 * If your app grows a real authorization model, replace this — but keep the
 * property that matters: this is a UI/UX gate only. de-hub re-checks every
 * write against the same app's configured admin roles, and that check is the
 * boundary. Nothing here protects anything.
 */
import { useContext, useMemo } from "react";

import { AppContext } from "../AppContextProvider";
import { hasAdminRole } from "../config/appSupport";

export const useIsAdmin = () => {
  const ctx = useContext(AppContext);
  const roles = ctx?.roles;

  return useMemo(() => {
    const list = Array.isArray(roles) ? roles : [];
    return { roles: list, isAdmin: hasAdminRole(list) };
  }, [roles]);
};

export default useIsAdmin;
